'use strict';
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const ModalView = require('common/ui/view/modal/index');
const Uploader = require('data/ui/view/content/uploader');
const URIObjectAPI = require('data/infra/api/object/index');
const ContentListView = require('data/ui/view/content/list');
const ContainerRepository = require('data/domain/repository/container/index');
const ContentRepository = require('data/domain/repository/content/index');
const ContentService = require('data/app/service/content/index');
const OriginalContentItemView = require('data/ui/view/content/item');
const Template = require('balus/ui/template/modal/data-content-selector.hbs');

const ContentItemView = OriginalContentItemView.extend({
    className: 'list-item list-item-clickable',
    triggers: {
        'click': 'select'
    }
});

const ContentSelectorView = Mn.View.extend({
    template: Template,
    ui: {
        saveButton: '.save'
    },
    events: {
        'click @ui.saveButton': 'save'
    },
    regions: {
        uploader: '.content-uploader',
        contentList: '.content-list',
        messagePanelContent: '.message-panel-content'
    },
    childViewEvents: {
        addedfile: 'onAddedFile',  // Uploader
        success: 'onSuccess',  // Uploader
        'select:existed': 'selectExisted'
    },
    bindings: {
        'input.nameUpload': 'name',
        'input.nameURI': 'name',
        'input.uri': 'uri'
    },
    modelEvents: {
        'change:name': 'uploadable',
        'change:uri': 'uploadable',
        'change:storageObjectId': 'uploadable'
    },

    initialize: function() {
        this.model = new Backbone.Model();
    },

    templateContext: function() {
        return {
            imageOnly: this._isAcceptImage(),
            hideURLInput: this.getOption('hideURLInput'),
            hideInputSelector: this.getOption('hideInputSelector')
        }
    },

    onRender: function () {
        const project = this.getOption('project');
        const accept = this.getOption('accept');
        const acceptImage = this._isAcceptImage();
        const acceptXLS = this._isAcceptXLS();
        const acceptXMI = this._isAcceptXMI();
        const messagePanelContent = this.getOption('messagePanelContent');

        this.showChildView('uploader', new Uploader({
            projectId: project.id,
            accept: accept
        }));
        ContainerRepository.find(project)
            .fetchRootOnce()
            .then(rootContainer => {
                ContentRepository.find(project)
                    .fetchContentsOnce(rootContainer.id, 5)
                    .then(contents => {
                        this.showChildView('contentList',
                            new ContentListView({
                                childView: ContentItemView,
                                childViewTriggers: {
                                    'select': 'select:existed'
                                },
                                collection: contents,
                                filter: function(child) {
                                    if(child.isDeleted()) {
                                        return false;
                                    }

                                    if(!accept) {
                                        return true;
                                    }

                                    // acceptImage の場合、画像は表示する
                                    if(acceptImage && child.getLatestVersion().isImage()) {
                                        return true;
                                    }

                                    // acceptXLS の場合、xls は表示する
                                    if(acceptXLS && child.getLatestVersion().isXLS()) {
                                        return true;
                                    }

                                    // acceptXMI の場合、xmi は表示する
                                    if(acceptXMI && child.getLatestVersion().isXMI()) {
                                        return true;
                                    }

                                    return false;
                                }
                            })
                        );
                    });
            });

        if (messagePanelContent) {
            this.showChildView('messagePanelContent', messagePanelContent);
            this.$('.message-panel').show();
        } else {
            this.$('.message-panel').hide();
        }

        this.stickit(this.model);

        this.listenTo(this.model, 'change:uri', () => {
            if(!this.model.get('uri')) {
                return;
            }

            URIObjectAPI.getURIObject(this.model.get('uri'))
                .then(obj => {
                    if(!this.model.get('name')) {
                        this.$('input.nameURI').val(obj.title);
                        this.$('input.nameURI').trigger('input');
                    }
                });
        });

        return this;
    },

    onAddedFile: function(file) {
        this.$('.save').attr('disabled', 'disabled');
        this.model.set({name: file.name});
    },

    onSuccess: function(file, j) {
        this.model.set({
            storageObjectId: j.id,
            thumbnailURI: j.thumbnailURI,
            uploaded: true
        });
    },

    uploadable: function () {
        if(this.model.get('name') && this.model.get('uri')){
            this.enableSaveButton();
        } else if(this.model.get('name') && this.model.get('storageObjectId')) {
            this.enableSaveButton();
        } else {
            this.disableSaveButton();
        }
    },

    enableSaveButton: function() {
        this.ui.saveButton.removeAttr('disabled');
    },

    disableSaveButton: function() {
        this.ui.saveButton.attr('disabled', 'disabled');
    },

    onChildviewSelectExisted: function(child) {
        this.trigger('select', child.model);
    },

    save: function () {
        if(!this.model.get('name')) {
            return;
        }
        if(!(this.model.get('storageObjectId') || this.model.get('uri'))) {
            return;
        }

        (new ContentService.ContentAddService({
            project: this.getOption('project'),
            name: this.model.get('name'),
            uri: this.model.get('uri'),
            storageObjectId: this.model.get('storageObjectId'),
            thumbnailURI: this.model.get('thumbnailURI'),
            uploaded: true,
            parentContainer: 'root'
        }))
            .add()
            .then(content => {
                this.trigger('select', content);
            });
    },

    _isAcceptImage: function() {
        return _.contains(this.getOption('accept'), 'image');
    },

    _isAcceptXLS: function() {
        return _.contains(this.getOption('accept'), 'xls');
    },

    _isAcceptXMI: function() {
        return _.contains(this.getOption('accept'), 'xmi');
    }
});

/**
 * Data Content を選択させるための View
 *
 * `showChildView` で render した後 `show` メソッドを呼ぶことで、
 * 選択用のモーダルが表示されます。
 *
 * Content がアップロードまたは選択されると 'select' イベントが発火して
 * 第一引数に Content Entity が渡されます。
 * 以下のように親の View で 'select' イベントを listen して下さい。
 *
 * @example
 * this.listenTo(contentSelector, 'select', function(content) {
 *     ...
 * });
 *
 * @param option {object}
 * @param option.project {Project} - アップロード先/選択元のプロジェクト
 * @param option.accept {array} - アップロードできるファイルの種類を文字列の配列で渡します
 *    サポートしているのは 'image', 'xls' です。
 *    未指定の場合は全種類のファイルを受け入れます。
 * @param option.hideURLInput {boolean} - true の場合 URL/Path の入力はできないようにします
 * @param option.messagePanelContent {object} - アップロードモーダルの上部に表示するメッセージを指定します (省略可)
 *
 */
module.exports = Mn.View.extend({
    template: false,
    show: function() {
        const project = this.getOption('project');
        const accept = this.getOption('accept');
        const hideURLInput = this.getOption('hideURLInput');
        const hideInputSelector = this.getOption('hideInputSelector');
        const messagePanelContent = this.getOption('messagePanelContent');
        let title = this.getTitle();
        const self = this;

        this._modal = new ModalView({
            title: title,
            bodyView:
                new ContentSelectorView({
                    project: project,
                    accept: accept,
                    hideURLInput: hideURLInput,
                    hideInputSelector: hideInputSelector,
                    messagePanelContent: messagePanelContent
                }),
            footerView: new Mn.View({template: false}),
            onChildviewSelect: function(content) {
                self.trigger('select', content);
            }
        });
        this._modal.show();
    },
    hide: function() {
        this._modal.hide();
    },

    getTitle: function() {
        if(this.getOption('title')) {
            return this.getOption('title');
        }

        const accept = this.getOption('accept');
        if(accept && accept.length == 1 && accept[0] == 'image') {
            return i18n.t('balus_view_modal:data-content-selector.title.imageOnly');
        }

        return i18n.t('balus_view_modal:data-content-selector.title.all');
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/modal/data-content-selector.js